// region Component Preferences

export const PERIOD = Object.freeze({
    LAST_DAY: '1',
    LAST_WEEK: '7',
    LAST_MONTH: '30'
});

export const VIEW = Object.freeze({
    CAROUSEL: 'carousel',
    TABLE: 'table',
    LINE: 'line'
});

export const WINNER_INFO = Object.freeze({
    INITIALS: 'initials',
    NICKNAME: 'nickname'
});

// endregion

// region Carousel

export const CAROUSEL_SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    controls: {
        arrows: { enabled: true },
        bullets: { enabled: false }
    }
};

export const CAROUSEL_MIN_ITEMS_PER_SLIDE = 2;

export const CAROUSEL_ITEM_MIN_WIDTH = 200;

// endregion

// region Table

export const TABLE_ANIMATION_INTERVAL = 4000;

// endregion

// region Line

export const LINE_ANIMATION_SPEED = 50;

// endregion
